import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import TextField from '@mui/material/TextField'
import React from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'
import MediaQuery from 'react-responsive'
import * as S from './styles'
import Relaxation from '../../images/relaxation.svg'
import { integrate } from '../RDIntegration'

const getContentText = (state, values, errors, handleChange) => {
	return {
		1: <div>
			<strong>Não sabe quanto vai receber do INSS e nem quando poderá se aposentar?</strong>
			<br/>
			<br/>
			O consultor do <strong>Monefica</strong> te ajuda a descobrir essas informações e monta o planejamento da sua aposentadoria.
			<br/>
			<br/>
			Quer saber quando vai se aposentar e quanto vai receber?
		</div>,
		2: <div>
			O consultor vai agendar um horário para conversar com você, basta deixar seu contato. Em nenhum momento usaremos seu email para envio de Spams.
			<TextField
			fullWidth variant="filled"
			id="name" name="name" type="text"
			onChange={handleChange}
			value={values.name} label="Nome"
			error={!!errors.name} helperText={errors.name || ' '}
			/>
			<TextField
			fullWidth variant="filled"
			id="email" name="email" type="email"
			onChange={handleChange}
			value={values.email} label="Email"
			error={!!errors.email} helperText={errors.email || ' '}
			/>
		</div>,
		3: <div>Agora é só aguardar o contato do consultor financeiro.
			Ele vai te ajudar em todo o seu planejamento futuro.</div>
	}[state.step]
}
const getDialogAction = (state, setState, handleCloseDialog, data, handleSubmit, values) => {
	return {
		1: <DialogActions>
			<Button onClick={() => {
				setState({ step: 2 })
			}} variant={'contained'} color="primary">
				SIM
			</Button>
			<Button onClick={()=>{
				handleCloseDialog()
			}} variant={'contained'} color="secondary">
				VOLTAR
			</Button>
		</DialogActions>,
		2: <S.Buttons className="actions-modal">
			<Button disabled={!values.name || !values.email} onClick={()=>{

				handleSubmit()
			}} variant={'contained'} color="primary">
				SOLICITAR AGENDAMENTO
			</Button>
			<Button className="btn-close" onClick={() =>{
				handleCloseDialog()
			}} variant={'contained'} color="secondary">
				FECHAR
			</Button>
		</S.Buttons>,
		3: <DialogActions>
			<Button onClick={handleCloseDialog} variant={'contained'} color="secondary">
				FECHAR
			</Button>
		</DialogActions>
	}[state.step]
}

const DialogSchema = Yup.object().shape({
	name: Yup.string()
	.required('Preencha este campo.')
	.min(3, 'O nome deve ter pelo menos 3 letras.'),
	email: Yup.string()
	.email('Email inválido.')
	.required('Preencha este campo.'),
})

export function ConversionDialog({ initialStep, open, handleCloseDialog, data }) {
	const [state, setState] = React.useState({ step: initialStep })

	return (<Formik
	validateOnBlur={false}
	validateOnChange={false}
	initialValues={{
		email: '',
		name: ''
	}}
	validationSchema={DialogSchema}
	onSubmit={(values) => {
		if (process.env.NODE_ENV !== 'development') {
			integrate(data, {
				name: values.name,
				email: values.email
			})
			.then(() => setState({ step: 3 }))
			.catch((e) => alert('Ocorreu um erro, por favor recarregue a página e tente novamente.'))
		} else {
			setState({ step: 3 })
		}
	}}>
		{({ values, errors, handleChange, handleSubmit, dirty, setFieldValue }) => (<Dialog
		open={open}
		onClose={handleCloseDialog}
		aria-labelledby="alert-dialog-title"
		aria-describedby="alert-dialog-description"
		>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					<S.Row>
						<MediaQuery query="(min-width: 768px)">
							<S.BoxImage>
								<S.Image src={Relaxation} alt="Qual seu INSS?" title="Qual seu INSS?"/>
							</S.BoxImage>
						</MediaQuery>
						{getContentText(state, values, errors, handleChange)}
					</S.Row>
				</DialogContentText>
			</DialogContent>
			{getDialogAction(state, setState, handleCloseDialog, data, handleSubmit, values)}
		</Dialog>)}
	</Formik>)
}
